// ── Reusable y-axis scales ──────────────────────────────────────────────────
function buildTickAxis(max, step, title, formatTick = (v) => (v === 0 ? "00" : String(v))) {
    const tickValues = [];
    for (let v = 0; v <= max; v += step) {
        tickValues.push(v);
    }
    return { max, tickText: tickValues.map(formatTick), tickValues, title };
}
const Y_AXIS_2000_MAX = 2000;
const Y_AXIS_2000_STEP = 500;
const Y_AXIS_60_MAX = 60;
const Y_AXIS_10_STEP = 10;
const Y_AXIS_PERCENT_MAX = 100;
const Y_AXIS_2000_STEP_500 = (title) => buildTickAxis(Y_AXIS_2000_MAX, Y_AXIS_2000_STEP, title);
const Y_AXIS_60_STEP_10 = buildTickAxis(Y_AXIS_60_MAX, Y_AXIS_10_STEP, "Count (Cycles)");
const Y_AXIS_PERCENT = buildTickAxis(Y_AXIS_PERCENT_MAX, Y_AXIS_10_STEP, "Percentage", (v) => `${v}%`);
export const ENERGY_PRODUCTIVITY_METRIC_OPTIONS = [
    {
        chart: {
            showInBarText: true,
            type: "bar",
            xAxisTitle: "Material moved (tonnes)",
            yAxis: Y_AXIS_2000_STEP_500("tonnes")
        },
        dropdownLabel: "Material moved",
        legendLabel: "Material moved (tonnes)",
        value: "MaterialMoved"
    },
    {
        chart: {
            showInBarText: true,
            type: "bar",
            xAxisTitle: "Energy used per ton moved (kWh)",
            yAxis: Y_AXIS_2000_STEP_500("kWh")
        },
        dropdownLabel: "Energy used",
        legendLabel: "Energy used (kWh)",
        value: "EnergyUsed"
    },
    {
        chart: {
            showInBarText: true,
            type: "bar",
            xAxisTitle: "Load Count",
            yAxis: Y_AXIS_60_STEP_10
        },
        dropdownLabel: "Load Count",
        legendLabel: "Load Count",
        value: "LoadCount"
    },
    {
        chart: {
            showInBarText: true,
            type: "bar",
            xAxisTitle: "Idle Time",
            yAxis: Y_AXIS_PERCENT
        },
        dropdownLabel: "Idle Time",
        legendLabel: "Idle Time",
        value: "IdleTime"
    },
    {
        chart: { type: "donut" },
        dropdownLabel: "Cycle Time",
        legendLabel: "Cycle Time",
        value: "CycleTime"
    }
];
export const ENERGY_PRODUCTIVITY_ASSET_FILTERS = ["All", "Haulers", "Loaders"];
export const DEFAULT_ENERGY_PRODUCTIVITY_METRIC = "MaterialMoved";
export const DEFAULT_ENERGY_PRODUCTIVITY_ASSET_FILTER = "All";
/** Metrics the panel knows how to render, derived from the configured options. */
const SUPPORTED_ENERGY_PRODUCTIVITY_METRICS = new Set(ENERGY_PRODUCTIVITY_METRIC_OPTIONS.map((option) => option.value));
/** True when the given metric has a configured chart in the panel. */
export const isSupportedEnergyProductivityMetric = (metric) => SUPPORTED_ENERGY_PRODUCTIVITY_METRICS.has(metric);
